module.exports = __webpack_public_path__ + "media/svg/motivations-164cd826.svg";